import { mapDTO } from '@twistezo/ts-dto-mapper'

import { alertsFromDTO } from 'features/alerts/api/mappers/alertFromDTO'
import { DomainAmazonAlert } from 'features/globalSetup/features/amazon/types/domainAmazonAlert'
import { AdUnitAmazonSlice } from '../types'
import { AdUnitAmazonSliceDTO } from './types'

type From = AdUnitAmazonSliceDTO
type To = AdUnitAmazonSlice

export const fromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((data: From): To => {
    const { fieldAlerts } = data

    return {
      alerts: alertsFromDTO<DomainAmazonAlert>(fieldAlerts),
    }
  })
